import { ShopifyAppNames } from "@redotech/redo-model/sales-channels";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateCloudXIntegration = {
  name: "updateCloudXIntegration" as const,
  input: z.object({
    clientSecret: z.string().optional(),
    warehouseAsPlainString: z.string().optional(),
    testMode: z.boolean().optional(),
    autoProcessReturns: z.boolean().optional(),
    upcType: createEnum(["sku", "barcode"]).optional(),
    excludedAppNames: z.array(createEnum(ShopifyAppNames)).optional(),
  }),
  output: z.null(),
};

export type UpdateCloudXIntegrationInput = z.infer<
  typeof updateCloudXIntegration.input
>;
